import React from 'react';
import { LockIcon } from 'lucide-react';
export function AppWindow({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`overflow-hidden rounded-xl border border-white/10 bg-surface shadow-[0_40px_100px_-30px_rgba(0,0,0,0.6)] md:rounded-2xl ${className}`} data-id="element-54" data-mp="1yaa3r347478">
      <div className="flex h-9 items-center border-b border-white/[0.06] bg-[#141417] px-3 md:h-10 md:px-4" data-id="element-55" data-mp="3p6duesdnv3nd">
        <div className="flex w-12 gap-1.5" aria-hidden="true" data-id="element-56" data-mp="pnlcfd0456nh">
          <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" data-id="element-57" data-mp="krnxnb4i08ct" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" data-id="element-58" data-mp="gor973sa1i0y" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" data-id="element-59" data-mp="gr3zq5c3p0pm" />
        </div>
        <div className="mx-auto flex items-center gap-1.5 rounded-md bg-white/[0.06] px-3 py-1 text-[11px] text-white/55" data-id="element-60" data-mp="bpekselrc2w9">
          <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-61" data-mp="31cvqdibdd4rk" />
          profumind.app
        </div>
        <div className="w-12" aria-hidden="true" data-id="element-62" data-mp="2wi88w3es9amh" />
      </div>
      {children}
    </div>;
}